module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Ka-Lc.d67f08f6.png";